import axios from "axios";
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch, get } from "react-hook-form";
import { common } from "../../utils";
import { API_URL } from "./../../utils/api-utils";
import { GetUser } from "../../utils/sessions";
//Material
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { BoxTemplate1 } from "../../stories/Box";
import './styles.css';
//Component
import { BaseContainer } from "../../stories/base-container";
import { ReactTable } from "../../stories/react-table";
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import FormCheckBox from "../../stories/hook-controls/checkbox";
//Function
import {
  titleCase,
  setDataToFormHookV2,
  isEmptyStr,
} from "../../utils/common-function";
import * as alertDialog from "../../utils/alert";

function InventoryReport() {

  //Context

  //State
  const [DataList, setDataList] = useState([]);
  const [DataRow, setDataRow] = useState({});

  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  //---------------------------
  const Search = async () => {
    let res = await GetInventoryReport();
    setDataList(res);
  };
  useEffect(() => {
    Search();
  }, []);

  //Function
  const Edit = (row) => {
    onOpenEditModal();
    setDataRow(row);
  };
  const Delete = async (ID) => {
    let res = await alertDialog.ConfirmDelete();
    if (!res) return;
    let param = {
      REPORT_ID: ID,
    };
    let api_res = await DeleteInventoryReport(param);
    if (api_res) {
      Search();
      alertDialog.del_success();
    }
  };
  //Event
  const onOpenAddModal = () => {
    setOpenModal(true);
    setEditMode(false);
    setDataRow(null);
  };
  const onOpenEditModal = () => {
    setOpenModal(true);
    setEditMode(true);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };

  const tablecomponent = () => {
    return (
      <>
        <Box m={2} className="btnstyle">
          <Button variant="contained" onClick={onOpenAddModal}>
            New Report
          </Button>
        </Box>
      </>
    );
  };
  
  return (
    <>
      <BaseContainer>
        {/* <Typography style={{ marginLeft: "5px" }}>Report Inventory</Typography> */}
        <BoxTemplate1 height="80vh"  title="Report Inventory">
        <ReactTable
          keyField="REPORT_ID"
          data={DataList}
          columns={getInventoryReportColumns(Edit, Delete)}
          headcomponent={tablecomponent}
          exportCsv
          
          hover
        />
        </BoxTemplate1>
      </BaseContainer>
      <DataModal
        editmode={editMode ? 1 : 0}
        open={openModal}
        onClose={onCloseModal}
        search={Search}
        dataRow={DataRow}
      />
    </>
  );
}


function DataModal(props) {
  const { onClose } = props;
  const { open, editmode } = props;
  const { dataRow, search = () => {}, ...otherprops } = props;
  const method = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = method;

  //Effect
  useEffect(() => {
    if (!open) return;
    if (editmode) {
      let data = setDataToFormHookV2(dataRow);
      setTimeout(() =>
        data?.forEach(({ name, value }) => setValue(name, value))
      );
    }
  }, [dataRow, setValue, open, editmode]);

  const SaveDetail = async () => {
   
    clearErrors("REPORT_ID");
    clearErrors("REPORT_TYPE");
    clearErrors("REPORT_NAME");

    if (isEmptyStr(getValues().REPORT_ID)) {
      setError("REPORT_ID", {
        type: "manual",
        message: "The Report ID field is required",
      });
      return;
    }
    if (isEmptyStr(getValues().REPORT_TYPE)) {
      setError("REPORT_TYPE", {
        type: "manual",
        message: "The Report Type field is required",
      });
      return;
    }
    if (isEmptyStr(getValues().REPORT_NAME)) {
      setError("REPORT_NAME", {
        type: "manual",
        message: "The Report Name field is required",
      });
      return;
    }

    if(editmode === 0)
    {
      let res_dup = await CheckDulplicateInventoryReport({REPORT_ID: getValues().REPORT_ID})
      if(res_dup)
      {
        setError("REPORT_ID", {
          type: "manual",
          message: "Report ID is Duplicate.",
        });
        return;
      }
    }

    let param = {
      REPORT_ID: editmode ? dataRow?.REPORT_ID : getValues().REPORT_ID,
      REPORT_NAME: getValues().REPORT_NAME,
      REPORT_TYPE: getValues().REPORT_TYPE,
      SPI: Boolean(getValues().SPI),
      OWNER_DEPARTMENT: getValues().OWNER_DEPARTMENT,
      OWNER_CONTACT_NAME: getValues().OWNER_CONTACT_NAME,
      CONTACT_EMAIL_NAME: getValues().CONTACT_EMAIL_NAME,
      QVD_JOB_NAME: getValues().QVD_JOB_NAME,
      SESSION_OWNER: GetUser(),
    };

    let res = await SaveInventoryReport(param);
    if (res) {
      search();
      onClose();
      alertDialog.inform_success();
    }
  };

  // Props
  const inputProps = {
    readOnly: editmode ? true : false,
  };

  return (
    <div>
      <Modal
        {...otherprops}
        maxWidth="md"
        onSave={SaveDetail}
        title={editmode ? "Edit Report Inventory" : "Add Report Inventory"}
      >
        <FormProvider {...method}>
          <div>
            <Grid container spacing={1}>
              <Grid item md={12} xs={12}>
                <Box m={1}>
                  <FormInput name="REPORT_ID" label={titleCase("REPORT_ID")} variant={editmode ? "filled" : ""}
                    required={editmode ? false : true}
                    InputProps={inputProps} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="REPORT_TYPE" label={titleCase("REPORT_TYPE")} required />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="REPORT_NAME" label={titleCase("REPORT_NAME")}  required/>
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="OWNER_DEPARTMENT" label={titleCase("OWNER_DEPARTMENT")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput
                    name="OWNER_CONTACT_NAME"
                    label={titleCase("OWNER_CONTACT_NAME")}
                  />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="CONTACT_EMAIL_NAME" label={titleCase("CONTACT_EMAIL_NAME")} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box m={1}>
                  <FormInput name="QVD_JOB_NAME" label={titleCase("QVD_JOB_NAME")} />
                </Box>
              </Grid>
              <Grid item md={12} xs={12}>
                <Box ml={3} m={1}>
                    <FormCheckBox key="SPI" name="SPI" label="SPI" errorobj={errors}/>
                </Box>
              </Grid>
            </Grid>
          </div>
        </FormProvider>
      </Modal>
    </div>
  );
}

// Column
const getInventoryReportColumns = (editData, deleteData) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      csvExport: false,
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editData(row);
              }}
            />
            <DeleteIcon
              color="action"
              onClick={() => {
                deleteData(row.REPORT_ID);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "REPORT_TYPE",
      text: titleCase("REPORT_TYPE"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "REPORT_ID",
      text: titleCase("REPORT_ID"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "REPORT_NAME",
      text: titleCase("REPORT_NAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "SPI",
      text: titleCase("SPI"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "OWNER_DEPARTMENT",
      text: titleCase("OWNER_DEPARTMENT"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "OWNER_CONTACT_NAME",
      text: titleCase("OWNER_CONTACT_NAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "CONTACT_EMAIL_NAME",
      text: titleCase("CONTACT_EMAIL_NAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "QVD_JOB_NAME",
      text: titleCase("QVD_JOB_NAME"),
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
  ];
  return columns;
};

// api
const GetInventoryReport = async (param) => {
  let url = `${API_URL.Job}/api/Master/GetInventoryReport`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

const SaveInventoryReport = async (param) => {
  let url = `${API_URL.Job}/api/Master/SaveInventoryReport`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

const DeleteInventoryReport = async (param) => {
  let url = `${API_URL.Job}/api/Master/DeleteInventoryReport`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

const CheckDulplicateInventoryReport = async (param) => {
  let url = `${API_URL.Job}/api/Master/CheckDulplicateInventoryReport`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export default InventoryReport;
